"use client";

import React from "react";
import { StyledSection } from "./hubBenefits.styles";

export interface IHubBenefit {
  title: string;
  body: string;
  icon: React.ReactNode;
}

interface IHubBenefitsProps {
  heading: string;
  benefits: IHubBenefit[];
}

export const HubBenefits = ({ heading, benefits }: IHubBenefitsProps) => {
  return (
    <StyledSection>
      <div className="inner">
        <header>
          <h2>{heading}</h2>
        </header>
        <ul className="grid">
          {benefits.map((b) => (
            <li key={b.title} className="card">
              <span className="icon" aria-hidden="true">
                {b.icon}
              </span>
              <h3>{b.title}</h3>
              <p>{b.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </StyledSection>
  );
};
